import React from 'react';
import AdotarCatalog from './AdotarCatalog';
import SEO from '../components/SEO';

const AdotarGatos: React.FC = () => (
  <>
    <SEO
      title="Gatos para Adoção no Porto | Patinhas Sem Lar"
      description="Conheça gatos disponíveis para adoção responsável através da Patinhas Sem Lar."
      path="/adotar/gatos"
    />
    <AdotarCatalog
      kind="cat"
      chapter="Cap. II · Gatos à espera"
      title="Os de quatro patas pequenos."
      subtitle="Curiosos, independentes, faladores ou silenciosos. Carrega numa ficha para conheceres a sua janela favorita."
    />
  </>
);

export default AdotarGatos;
